import React from 'react';
import { useContext, createContext, useState} from "react";
import { useServerProps } from '../../serverProps';
import { useAuthorisation } from '../LoginPage/AuthorisationProvider';
import { getIngredientsData, deleteIngredient, updateIngredient, addIngredient, cancelIngredientReservation } from "./IngredientsData"
import { getRecipesData, deleteRecipe, submitRecipe } from "./RecipesData"
import { getPlansData, addRecipePlan, deleteRecipePlan, handlePair, handleShopPlan } from "./PlansData"
import { getShoppingListData, addShoppingListItem, editShoppingListItem, deleteShoppingListItem, buyShoppingListItem } from "./ShoppingListData"


const DataContext = createContext();

const DataProvider = ({ children }) => {

    const userID = useAuthorisation().userID;
    const serverProps = useServerProps();

    const [ingredients, setIngredients] = useState([])
    const [recipes, setRecipes] = useState([])
    const [plans, setPlans] = useState([])
    const [shoppingList, setShoppingList] = useState([])
    const [ingredientServerAccess, setIngredientServerAccess] = useState(-2)
    const [recipesServerAccess, setRecipesServerAccess] = useState(-2)
    const [plansServerAccess, setPlansServerAccess] = useState(-2)
    const [shoppingListServerAccess, setShoppingListServerAccess] = useState(-2)

    const initialAccess = () => {
             getIngredientsData(serverProps, userID, ingredients, setIngredients, setIngredientServerAccess)
             getRecipesData(serverProps, userID, recipes, setRecipes, setRecipesServerAccess)
             getPlansData(serverProps, userID, plans, setPlans, setPlansServerAccess)
             getShoppingListData(serverProps, userID, shoppingList, setShoppingList, setShoppingListServerAccess)
    }

    if ((ingredientServerAccess === -2) 
        && (recipesServerAccess === -2) 
        && (plansServerAccess === -2) 
        && (shoppingListServerAccess === -2) && userID) {
        initialAccess();
    }

    const ingredientsData = {
        ingredients,
        setIngredients,
        getIngredientsData: (startInd, amount) => getIngredientsData(serverProps, userID, ingredients, setIngredients, setIngredientServerAccess, startInd, amount),
        deleteIngredient: (ingredient) => deleteIngredient(serverProps, userID, ingredients, setIngredients, plans, setPlans, ingredient),
        changeIngredient: (ingredient) => updateIngredient(serverProps, userID, ingredients, setIngredients, ingredient),
        submitIngredient: (ingredient) => addIngredient(serverProps, userID, ingredients, setIngredients, ingredient),
        cancelIngredientReservation: (ingredient) => cancelIngredientReservation(serverProps, userID, ingredients, setIngredients, plans, setPlans, ingredient),
        serverAccess: ingredientServerAccess
    }

    const recipesData = {
        recipes,
        setRecipes,
        getRecipesData: (startInd, amount) => getRecipesData(serverProps, userID, recipes, setRecipes, setRecipesServerAccess, startInd, amount),
        deleteRecipe: (recipe) => deleteRecipe(serverProps, userID, recipes, setRecipes, plans, setPlans, recipe),
        submitRecipe: (recipe) => submitRecipe(serverProps, userID, recipes, setRecipes, plans, setPlans, recipe),
        serverAccess: recipesServerAccess
    }

    const planData = {
        plans,
        setRecipePlans: setPlans,
        getNewPlans: (startInd, amount) => getPlansData(serverProps, userID, plans, setPlans, setPlansServerAccess, startInd, amount),
        addNewRecipePlan: (recipe, activeDate) => addRecipePlan(userID, serverProps, plans, setPlans, recipe, activeDate),
        handleDeletePlan: (Plan_ID) => deleteRecipePlan(userID, serverProps, plans, setPlans, Plan_ID),
        handlePlanIngredientPair: (highlightedIngredient, listIngredient) => handlePair(serverProps, userID, plans, setPlans, ingredients, setIngredients, highlightedIngredient, listIngredient),
        handleShopPlan: (highlightedIngredient, recipe) => handleShopPlan(serverProps, userID, plans, setPlans, shoppingList, setShoppingList, highlightedIngredient, recipe),
        serverAccess: plansServerAccess
    }

    const shoppingListData = {
        shoppingList,
        getNewShoppingListData: (startInd, amount) => getShoppingListData(serverProps, userID, shoppingList, setShoppingList, setShoppingListServerAccess, startInd, amount),
        addShoppingListItem: (itemData) => addShoppingListItem(serverProps, userID, shoppingList, setShoppingList, itemData),
        editShoppingListItem: (itemData) => editShoppingListItem(serverProps, userID, shoppingList, setShoppingList, itemData),
        deleteShoppingListItem: (itemData) => deleteShoppingListItem(serverProps, userID, shoppingList, setShoppingList, plans, setPlans, itemData),
        buyShoppingListItem: (itemData) => buyShoppingListItem(serverProps, userID, shoppingList, setShoppingList, setIngredients, ingredients, plans, setPlans, itemData),
        serverAccess: shoppingListServerAccess
    }



    return (
        <DataContext.Provider value={{
            ingredientsData,
            recipesData,
            planData,
            shoppingListData
        }}>
            {children}
        </DataContext.Provider>
    )
}


export default DataProvider;

export const useData = () => {
    return useContext(DataContext);
}